module.exports = __webpack_public_path__ + "static/media/hygie.4612e5b9.svg";